import { useState } from "react";

const ENTITY_LOADED = "entity-loaded";

export function useEditMode() {
  const [counter, setCounter] = useState(0);

  const onEntityLoaded = () => {
    setCounter((prev) => prev + 1);
  };

  const status = `${ENTITY_LOADED}-${counter}`;

  return {
    formKey: status,
    onEntityLoaded,
  };
}
